const KEY = 'elevate_readiness_attempt_v3';

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

export const newAttempt = (questions) => ({
  id: `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`,
  order: Object.fromEntries(questions.map((q) => [q.id, shuffle(q.options.map((o) => o.id))])),
  answers: {},
  current: 0,
  step: 'assessment',
});

const matches = (attempt, questions) => questions.every((q) => {
  const ids = attempt.order?.[q.id];
  return Array.isArray(ids) && ids.length === q.options.length && q.options.every((o) => ids.includes(o.id));
});

export const loadAttempt = (questions) => {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && matches(saved, questions) && ['assessment', 'lead-capture'].includes(saved.step)) return saved;
  } catch (e) { /* corrupted entry: start fresh */ }
  localStorage.removeItem(KEY);
  return null;
};

export const saveAttempt = (attempt) => localStorage.setItem(KEY, JSON.stringify(attempt));
export const clearAttempt = () => localStorage.removeItem(KEY);
